var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "blubber_thread",
      class: {
        dragover: _vm.dragging,
      },
      attrs: {
        id: "blubberthread_" + _vm.threadData.thread_posting.thread_id,
      },
      on: {
        dragover: function dragover($event) {
          $event.preventDefault()
          return _vm.dragover.apply(null, arguments)
        },
        dragleave: function dragleave($event) {
          $event.preventDefault()
          return _vm.dragleave.apply(null, arguments)
        },
        drop: function drop($event) {
          $event.preventDefault()
          return _vm.upload.apply(null, arguments)
        },
      },
    },
    [
      _vm.threadData.notifications
        ? _c(
            "div",
            {
              staticClass: "hidden-medium-up context_info",
            },
            [
              _c(
                "a",
                {
                  staticClass: "followunfollow",
                  class: {
                    unfollowed: !_vm.threadData.followed,
                  },
                  attrs: {
                    href: "#",
                    title: _vm.$gettext(
                      "Benachrichtigungen für diese Konversation abstellen."
                    ),
                    "data-thread_id": _vm.thread_data.thread_posting.thread_id,
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      return _vm.toggleFollow()
                    },
                  },
                },
                [
                  _c("StudipIcon", {
                    staticClass: "follow text-bottom",
                    attrs: {
                      shape: "decline",
                      size: 20,
                    },
                  }),
                  _vm._v(" "),
                  _c("StudipIcon", {
                    staticClass: "unfollow text-bottom",
                    attrs: {
                      shape: "notification2",
                      size: 20,
                    },
                  }),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$gettext("Benachrichtigungen aktiviert")) +
                      "\n        "
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "scroll",
              rawName: "v-scroll",
            },
          ],
          staticClass: "scrollable_area",
        },
        [
          _c(
            "div",
            {
              staticClass: "all_content",
            },
            [
              _vm.hasContent(_vm.threadData.thread_posting.content)
                ? _c(
                    "div",
                    {
                      staticClass: "thread_posting",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "contextinfo",
                        },
                        [
                          _c("studip-date-time", {
                            attrs: {
                              timestamp: _vm.threadData.thread_posting.mkdate,
                              relative: true,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.getUserProfileURL(
                                  _vm.threadData.thread_posting.user_id,
                                  _vm.threadData.thread_posting.user_username
                                ),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.threadData.thread_posting.user_name)
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("a", {
                            staticClass: "avatar",
                            style: {
                              backgroundImage:
                                "url(" +
                                _vm.threadData.thread_posting.avatar +
                                ")",
                            },
                            attrs: {
                              href: _vm.getUserProfileURL(
                                _vm.threadData.thread_posting.user_id,
                                _vm.threadData.thread_posting.user_username
                              ),
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "content",
                        domProps: {
                          innerHTML: _vm._s(_vm.threadData.thread_posting.html),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "link_to_comments",
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hasContent(_vm.threadData.thread_posting.content) &&
              !_vm.threadData.comments.length
                ? _c(
                    "div",
                    {
                      staticClass: "empty_blubber_background",
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "translate",
                              rawName: "v-translate",
                            },
                          ],
                        },
                        [_vm._v("Starte die Konversation jetzt!")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ol",
                {
                  staticClass: "comments",
                  attrs: {
                    "aria-live": "polite",
                  },
                },
                [
                  _vm.threadData.more_up
                    ? _c(
                        "li",
                        {
                          staticClass: "more",
                        },
                        [
                          _c("studip-asset-img", {
                            attrs: {
                              file: "loading-indicator.svg",
                              width: "20",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.sortedComments, function (comment) {
                    return _c(
                      "li",
                      {
                        key: comment.comment_id,
                        class: comment.class,
                        attrs: {
                          "data-comment_id": comment.comment_id,
                        },
                      },
                      [
                        _c("a", {
                          staticClass: "avatar",
                          style: {
                            backgroundImage: "url(" + comment.avatar + ")",
                          },
                          attrs: {
                            href: _vm.getUserProfileURL(
                              comment.user_id,
                              comment.user_username
                            ),
                            title: comment.user_name,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "content",
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "name",
                                attrs: {
                                  href: _vm.getUserProfileURL(
                                    comment.user_id,
                                    comment.user_username
                                  ),
                                },
                              },
                              [_vm._v(_vm._s(comment.user_name))]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "html",
                              domProps: {
                                innerHTML: _vm._s(comment.html),
                              },
                            }),
                            _vm._v(" "),
                            _c("textarea", {
                              staticClass: "edit",
                              domProps: {
                                innerHTML: _vm._s(comment.content),
                              },
                              on: {
                                keydown: function keydown($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  if (
                                    $event.ctrlKey ||
                                    $event.shiftKey ||
                                    $event.altKey ||
                                    $event.metaKey
                                  ) {
                                    return null
                                  }
                                  return _vm.saveComment.apply(null, arguments)
                                },
                                keyup: function keyup($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "escape",
                                      undefined,
                                      $event.key,
                                      undefined
                                    )
                                  ) {
                                    return null
                                  }
                                  if (
                                    $event.ctrlKey ||
                                    $event.shiftKey ||
                                    $event.altKey ||
                                    $event.metaKey
                                  ) {
                                    return null
                                  }
                                  return _vm.editComment.apply(null, arguments)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "time",
                          },
                          [
                            _c("studip-date-time", {
                              attrs: {
                                timestamp: comment.mkdate,
                                relative: true,
                              },
                            }),
                            _vm._v(" "),
                            comment.writable
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "edit_comment",
                                    attrs: {
                                      href: "",
                                      title: _vm.$gettext("Bearbeiten."),
                                    },
                                    on: {
                                      click: function click($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.editComment.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("studip-icon", {
                                      attrs: {
                                        shape: "edit",
                                        size: "14",
                                        role: "inactive",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "answer_comment",
                                attrs: {
                                  href: "",
                                  title: _vm.$gettext("Hierauf antworten."),
                                },
                                on: {
                                  click: function click($event) {
                                    $event.preventDefault()
                                    return _vm.answerComment.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c("studip-icon", {
                                  attrs: {
                                    shape: "export",
                                    size: "14",
                                    role: "inactive",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.threadData.more_down
                    ? _c(
                        "li",
                        {
                          staticClass: "more",
                        },
                        [
                          _c("studip-asset-img", {
                            attrs: {
                              file: "loading-indicator.svg",
                              width: "20",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.threadData.thread_posting.commentable
        ? _c(
            "div",
            {
              staticClass: "writer",
            },
            [
              _c("studip-icon", {
                attrs: {
                  shape: "blubber",
                  size: "30",
                  role: "info",
                },
              }),
              _vm._v(" "),
              _c("textarea", {
                attrs: {
                  placeholder: _vm.writerTextareaPlaceholder,
                },
                on: {
                  keyup: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      if (
                        $event.ctrlKey ||
                        $event.shiftKey ||
                        $event.altKey ||
                        $event.metaKey
                      ) {
                        return null
                      }
                      return _vm.submit.apply(null, arguments)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp",
                        ])
                      ) {
                        return null
                      }
                      if (
                        $event.ctrlKey ||
                        $event.shiftKey ||
                        $event.altKey ||
                        $event.metaKey
                      ) {
                        return null
                      }
                      return _vm.editPreviousComment.apply(null, arguments)
                    },
                    _vm.saveCommentToSession,
                  ],
                  change: _vm.saveCommentToSession,
                },
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "send",
                  attrs: {
                    title: _vm.$gettext("Abschicken"),
                  },
                  on: {
                    click: _vm.submit,
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: "arr_2up",
                      size: "30",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "label",
                {
                  ref: "blubber_upload_file_label",
                  staticClass: "upload",
                  attrs: {
                    title: _vm.$gettext("Datei hochladen"),
                    tabindex: "0",
                  },
                  on: {
                    keydown: _vm.simulateClick,
                  },
                },
                [
                  _c("input", {
                    staticStyle: {
                      display: "none",
                    },
                    attrs: {
                      type: "file",
                      multiple: "",
                    },
                    on: {
                      change: _vm.upload,
                    },
                  }),
                  _vm._v(" "),
                  _c("studip-icon", {
                    attrs: {
                      shape: "upload",
                      size: "30",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasThreadsWidget
        ? _c(
            "MountingPortal",
            {
              attrs: {
                mountTo: "#blubber-threads-widget",
                name: "blubber-threads-widget",
              },
            },
            [
              _c("blubber-thread-widget", {
                attrs: {
                  threads: _vm.$root.threads,
                  active_thread: _vm.$root.active_thread,
                  more_down: _vm.$root.threads_more_down,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }